import CreateDonation from '@/core/pages/donation/CreateDonation/CreateDonation';

export default CreateDonation;
